import { render, staticRenderFns } from "./DlgImagesUploadBuffer.vue?vue&type=template&id=3ed754ed&scoped=true"
import script from "./DlgImagesUploadBuffer.vue?vue&type=script&lang=js"
export * from "./DlgImagesUploadBuffer.vue?vue&type=script&lang=js"
import style0 from "./DlgImagesUploadBuffer.vue?vue&type=style&index=0&id=3ed754ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed754ed",
  null
  
)

export default component.exports